export const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "suspended", label: "Suspended" },
    { value: "expired", label: "Expired" }
];

export const invoicePaymentOptions = [
    { value: "paid", label: "Paid" },
    // { value: "partially paid", label: "Partially Paid" },
    { value: "pending", label: "Pending" },
];

export const paymentStatusOptions = [
    { value: "complete", label: "Complete" },
    { value: "pending", label: "Pending" },
    { value: "failed", label: "Failed" },
]

export const PlanTypeOptions = [
    {value: "paid",label :"Paid"},
    {value: "free",label: "Free"},
]
export const monthOptions = [
  { label: "All Months", value: "" },
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];